export const DEFAULT_PORTAL_CONFIGURATION = {
  isDefaultConfiguration: true,
  background_image_url: "/images/_default-background.jpg",
  mobile_background_image_url: "/images/_default-background-mobile.jpg",
  logo_image_url: "/images/_wifirst_default_logo.svg",
  main_color: '#008cea'
}
